import { mapGetters, mapActions } from 'vuex'

export const signersStoreActions = {
  ...mapActions('signersStore', [
    'addSigner',
    'removeSigner',
    'showAddSigner',
    'hideAddSigner',
    'setUserSigner',
    'resetSignersStore',
    'saveSigners',
    'notifySigners',
    'notifySignerById',
    'addSignerToDocument',
    'updateSignerToDocument',
    'deleteSignerToDocument',
    'reminderSignerToDocument',
    'setFirmarEnOrden'
  ])
}

export const signersStoreData = {
  ...mapGetters('signersStore', [
    'signers',
    'signersHeaders',
    'signersHeadersEdit',
    'addSignerVisible',
    'signersNoDataText',
    'isUserSigner',
    'signerDeleteLastLabels',
    'signerDeleteLabels',
    'signerReminderLabels',
    'isDeleting',
    'firmarEnOrden',
    'msgSignerServiceError',
    'msgSignerServiceDeleteError',
    'msgSignerServiceReminderError'
  ])
}
